/** @jsx jsx */
import { Status, StatusVariant } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { TimeReportStage } from "@/data/time-reports";

const mapStageToStatusVariant: Record<TimeReportStage, StatusVariant> = {
  APPROVED: "success",
  DRAFT: "secondary",
  IN_APPROVAL: "info",
  REJECTED: "danger",
  REVISED: "info",
  UPDATED: "info",
};

const mapStageToTranslationKey: Record<TimeReportStage, string> = {
  APPROVED: "TIME_REPORTS.STAGE.APPROVED",
  DRAFT: "TIME_REPORTS.STAGE.DRAFT",
  IN_APPROVAL: "TIME_REPORTS.STAGE.IN_APPROVAL",
  REJECTED: "TIME_REPORTS.STAGE.REJECTED",
  REVISED: "TIME_REPORTS.STAGE.REVISED",
  UPDATED: "TIME_REPORTS.STAGE.UPDATED",
};

interface TimeReportStageStatusProps {
  stage: TimeReportStage;
}

export const TimeReportStageStatus: FC<TimeReportStageStatusProps> = ({ stage }) => {
  const { t } = useTranslation("session");

  const variant = mapStageToStatusVariant[stage];
  const content = t(mapStageToTranslationKey[stage]);

  return <Status variant={variant}>{content}</Status>;
};
